import React from 'react';

const ComingSoonPage = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg"
          alt="Brick Lane Restaurant"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Centered Content */}
      <div className="relative z-10 text-center px-6">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src="/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg"
            alt="Brick Lane Logo"
            className="h-20 md:h-28 w-auto object-contain mx-auto"
          />
        </div>

        {/* Coming Soon */}
        <p 
          className="text-white/90 text-2xl md:text-3xl tracking-[0.3em] uppercase font-light"
        >
          Coming Soon
        </p>

        {/* Subtle location */}
        <p className="text-white/60 text-sm md:text-base mt-8 tracking-widest uppercase">
          Arts District, Los Angeles
        </p>
      </div>
    </div>
  );
};

export default ComingSoonPage;
